module.exports = __webpack_public_path__ + "img/right2.ca61d5d1.png";